import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL?.trim()
  ? `${process.env.REACT_APP_API_URL.trim().replace(/\/$/, '')}/api`
  : '/api';

export function clearAuthStorage() {
  localStorage.removeItem('daima_token');
  localStorage.removeItem('daima_user');
  localStorage.removeItem('daima_auth');
}

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('daima_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const requestUrl = err.config?.url || '';
    const isLoginRequest = requestUrl.includes('/auth/login');

    if (status === 401 && !isLoginRequest) {
      clearAuthStorage();
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const login = (creds) => api.post('/auth/login', creds);
export const getMe = () => api.get('/auth/me');
export const changePassword = (payload) => api.post('/auth/change-password', payload);

export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getByBarcode = (code) => api.get(`/products/barcode/${code}`);
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.patch(`/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/products/${id}`);
export const restockProduct = (id, data) => api.post(`/products/${id}/restock`, data);

export const getCategories = () => api.get('/categories');
export const createCategory = (data) => api.post('/categories', data);
export const updateCategory = (id, data) => api.patch(`/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

export const getSuppliers = () => api.get('/suppliers');
export const createSupplier = (data) => api.post('/suppliers', data);
export const updateSupplier = (id, data) => api.patch(`/suppliers/${id}`, data);
export const deleteSupplier = (id) => api.delete(`/suppliers/${id}`);

export const getSales = (params) => api.get('/sales', { params });
export const getSale = (id) => api.get(`/sales/${id}`);
export const getSummary = (params) => api.get('/sales/summary', { params });
export const createSale = (data) => api.post('/sales', data);
export const refundSale = (id) => api.post(`/sales/${id}/refund`);

export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.patch(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const resetUserPassword = (id, newPassword) => api.post(`/users/${id}/reset-password`, { newPassword });

export const getSettings = () => api.get('/settings');
export const saveSettings = (data) => api.put('/settings', data);

export const printJob = (type, payload, device_id) => api.post('/print', { type, payload, device_id });
export const getPrintJobs = () => api.get('/print');
export const testPrinterConnection = (host, port) => api.post('/print/test-connection', { host, port });

export const getSalesReport = (params) => api.get('/reports/sales', { params });
export const getInventoryReport = () => api.get('/reports/inventory');
export const getEmployeeReport = (params) => api.get('/reports/employees', { params });

export const getAlerts = () => api.get('/alerts');
export const markAllAlertsRead = () => api.post('/alerts/mark-all-read');
export const dismissAlert = (id) => api.post(`/alerts/${id}/dismiss`);
